import Controller from "./pickLocationMap.controller";
import template from "./pickLocationMap.html";

const pickLocationMap = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    name: "@",
    componentTitle: "@",
    isEdit: "<",
    isRequired: "<",
    isEnabled: "<",
    permissionName: "@",
    eventName: "<",
    resourceMethod: "@",
    resourceMethodName: "@",
  },
};

export default pickLocationMap;



// WEBPACK FOOTER //
// ./src/components/pickLocationMap/pickLocationMap.component.js